// Copyright (c) 2016 Deere & Company

import ActionsPopoverLink from '../../../shared/state/actions-popover-link';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';

const createLink = (label, route) =>
    new ActionsPopoverLink({
        label,
        route
    });

const getId = (object, pipId) =>
    object.id ? object.id : `${pipId}-${object.pin}`;

const getPipId = (object, pipId) =>
    pipId ? pipId : object.pipId;

/* eslint-disable complexity */

export const getPipActions = (context, object, pipId) => {

    const security = context.security;
    const privacy = context.user.privacy;
    const actionList = [];
    const id = getId(object, pipId);
    const pipIdToOpen = getPipId(object, pipId);

    if (hasAccess(security, 'PIP', 'PIP_CLAIM')) {

        actionList.push(createLink('CREATE_PIP_CLAIM', `/claims/pip/new/${object.pin}/${pipIdToOpen}`));

    }

    if (hasAccess(security, 'PIP', 'PIP_PIPCODE_REQUEST')) {

        actionList.push(createLink('REQUEST_PIP_CODE', `/pips/pip-code-request/${id}`));

    }

    if (hasAccess(security, 'PRT', 'PRT_STATUS_CHANGE')) {

        actionList.push(createLink('UPDATE_MACHINE_STATUS', `/products/status-change-request/${object.pin}`));

    }

    if (hasAccess(security, 'PRT', 'PRT_DEALER_TRANSFER')) {

        actionList.push(createLink('CHANGE_RESPONSIBLE_DEALER', `/products/new-transfer/${object.pin}`));

    }

    if (hasAccess(security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(privacy, 'registrationNotAllowed')) {

        actionList.push(createLink('REGISTER_PRODUCT', `/products/register-product?pin=${object.pin}`));

    }

    return actionList;

};

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/pip/shared/services/pip-actions.js